import { DEAL_WORKING_STATUS, TOGGLE_GROUP_OPTIONS } from 'partials/admin/dealworking/Header/constants';

export const parseSelectedIds = (objects) => {
	const ids = objects.map((item) => item.id).join(',');
	if (ids) return ids;
};

export const dealWorkingStatusWhitelistOptions = TOGGLE_GROUP_OPTIONS.filter(
	(option) => option.key !== DEAL_WORKING_STATUS.WORKING,
);

export const whitelistDealWorkingStatusValues = (values) => {
	const whitelist = dealWorkingStatusWhitelistOptions.map((opt) => opt.value);
	const splitValues = values.split(',');

	return splitValues.filter((val) => whitelist.includes(val)).join(',');
};
